import React from "react";
import PageTemplate from "../../templates/PageTemplate";
import Container from "../../templates/Container";

import styles from "./MobilePrivacy.module.scss";

const MobilePrivacy = () => {
  return (
    <PageTemplate>
      <Container>
        <div className={styles.text_container}>
          <h2>Политика конфиденциальности</h2>

          <div
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "10.0pt",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          // }}
          >
            <ol
            //   style={{
            //     marginBottom: "0cm",
            //     listStyleType: "decimal",
            //     marginLeft: "43.4px",
            //   }}
            >
              <li
              // style={{
              //   marginTop: "0cm",
              //   marginRight: "0cm",
              //   marginBottom: "10.0pt",
              //   marginLeft: "0cm",
              //   lineHeight: "115%",
              //   fontSize: 15,
              //   fontFamily: '"Calibri",sans-serif',
              // }}
              >
                <strong>
                  <span>ОБЩИЕ ПОЛОЖЕНИЯ</span>
                </strong>
              </li>
            </ol>
          </div>
          <p
          // style={{
          //   marginTop: "0cm",

          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span>&nbsp;</span>
          </p>
          <p>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.1. Настоящая Политика в отношении обработки персональных данных
              в автономной некоммерческой организации «Сибирский институт
              развития креативных индустрий» (далее – АНО «СИРКИ», Оператор) в
              отношении обработки персональных данных (далее - Политика)
              разработана во исполнение требований п. 2 ч. 1 ст. 18.1
              Федерального закона от 27.07.2006 № 152-ФЗ "О персональных данных"
              (далее - Закон о персональных данных) в целях обеспечения защиты
              прав и свобод человека и гражданина при обработке его персональных
              данных, в том числе защиты прав на неприкосновенность частной
              жизни, личную и семейную тайну.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.2. Политика действует в отношении всех персональных данных,
              которые обрабатывает Оператор.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.3. Политика распространяется на отношения в области обработки
              персональных данных, возникшие у Оператора как до, так и после
              утверждения настоящей Политики.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.4. Во исполнение требований ч. 2 ст. 18.1 Закона о персональных
              данных настоящая Политика публикуется в свободном доступе в
              информационно-телекоммуникационной сети Интернет на сайте
              Оператора.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.5. Основные понятия, используемые в Политике:
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                персональные данные
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- любая информация, относящаяся к прямо или косвенно
              определенному или определяемому физическому лицу (субъекту
              персональных данных);
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                субъект персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;– физическое лицо, указанное в п.4.2 настоящей Политики.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                оператор персональных данных (оператор)
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;– автономная некоммерческая организация «Сибирский институт
              развития креативных индустрий», АНО «СИРКИ», самостоятельно или
              совместно с другими лицами организующая и (или) осуществляющая
              обработку персональных данных, а также определяющая цели обработки
              персональных данных, состав персональных данных, подлежащих
              обработке, действия (операции), совершаемые с персональными
              данными;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                обработка персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- любое действие (операция) или совокупность действий
              (операций) с персональными данными, совершаемых с использованием
              средств автоматизации или без их использования.&nbsp;
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Обработка персональных данных включает в себя в том числе:
            </span>
          </p>
          <ul style={{ listStyleType: "disc", marginLeft: 17 }}>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                сбор;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                запись;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                систематизацию;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                накопление;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                хранение;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                уточнение (обновление, изменение);
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                извлечение;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                использование;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                передачу (распространение, предоставление, доступ);
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                обезличивание;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                блокирование;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                удаление;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                уничтожение;
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                автоматизированная обработка персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- обработка персональных данных с помощью средств
              вычислительной техники;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                распространение персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- действия, направленные на раскрытие персональных данных
              неопределенному кругу лиц;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                предоставление персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- действия, направленные на раскрытие персональных данных
              определенному лицу или определенному кругу лиц;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                блокирование персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- временное прекращение обработки персональных данных (за
              исключением случаев, если обработка необходима для уточнения
              персональных данных);
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                уничтожение персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- действия, в результате которых становится невозможным
              восстановить содержание персональных данных в информационной
              системе персональных данных и (или) в результате которых
              уничтожаются материальные носители персональных данных;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                обезличивание персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- действия, в результате которых становится невозможным без
              использования дополнительной информации определить принадлежность
              персональных данных конкретному субъекту персональных данных;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                информационная система персональных данных
              </span>
            </strong>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;- совокупность содержащихся в базах данных персональных
              данных и обеспечивающих их обработку информационных технологий и
              технических средств.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.6. Основные права и обязанности Оператора.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.6.1. Оператор<strong>&nbsp;</strong>имеет право:
            </span>
          </p>
          <ol
          // className="decimal_type"
          // style={{ listStyleType: "undefined", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                самостоятельно определять состав и перечень мер, необходимых и
                достаточных для обеспечения выполнения обязанностей,
                предусмотренных Законом о персональных данных и принятыми в
                соответствии с ним нормативными правовыми актами, если иное не
                предусмотрено Законом о персональных данных или другими
                федеральными законами;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                поручить обработку персональных данных другому лицу с согласия
                субъекта персональных данных, если иное не предусмотрено
                федеральным законом, на основании заключаемого с этим лицом
                договора. Лицо, осуществляющее обработку персональных данных по
                поручению Оператора, обязано соблюдать принципы и правила
                обработки персональных данных, предусмотренные Законом о
                персональных данных, соблюдать конфиденциальность персональных
                данных, принимать необходимые меры, направленные на обеспечение
                выполнения обязанностей, предусмотренных Законом о персональных
                данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                в случае отзыва субъектом персональных данных согласия на
                обработку персональных данных Оператор вправе продолжить
                обработку персональных данных без согласия субъекта персональных
                данных при наличии оснований, указанных в Законе о персональных
                данных.
              </span>
            </li>
          </ol>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.6.2. Оператор<strong>&nbsp;</strong>обязан:
            </span>
          </p>
          <ol
          // className="decimal_type"
          // style={{ listStyleType: "undefined", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                организовывать обработку персональных данных в соответствии с
                требованиями Закона о персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                отвечать на обращения и запросы субъектов персональных данных и
                их законных представителей в соответствии с требованиями Закона
                о персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                сообщать в уполномоченный орган по защите прав субъектов
                персональных данных (Федеральную службу по надзору в сфере
                связи, информационных технологий и массовых коммуникаций
                (Роскомнадзор)) по запросу этого органа необходимую информацию в
                течение 10 рабочих дней с даты получения такого запроса. Данный
                срок может быть продлен, но не более чем на пять рабочих дней.
                Для этого Оператору необходимо направить в Роскомнадзор
                мотивированное уведомление с указанием причин продления срока
                предоставления запрашиваемой информации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                в порядке, определенном федеральным органом исполнительной
                власти, уполномоченным в области обеспечения безопасности,
                обеспечивать взаимодействие с государственной системой
                обнаружения, предупреждения и ликвидации последствий
                компьютерных атак на информационные ресурсы РФ, включая
                информирование его о компьютерных инцидентах, которые повлекли
                неправомерную передачу (предоставление, распространение, доступ)
                персональных данных.
              </span>
            </li>
          </ol>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.7. Основные права субъекта персональных данных. Субъект
              персональных данных имеет право:
            </span>
          </p>
          <ol
          // className="decimal_type"
          // style={{ listStyleType: "undefined", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                получать информацию, касающуюся обработки его персональных
                данных, за исключением случаев, предусмотренных федеральными
                законами. Сведения предоставляются субъекту персональных данных
                Оператором в доступной форме, и в них не должны содержаться
                персональные данные, относящиеся к другим субъектам персональных
                данных, за исключением случаев, когда имеются законные основания
                для раскрытия таких персональных данных. Перечень информации и
                порядок ее получения установлен Законом о персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                требовать от оператора уточнения его персональных данных, их
                блокирования или уничтожения в случае, если персональные данные
                являются неполными, устаревшими, неточными, незаконно
                полученными или не являются необходимыми для заявленной цели
                обработки, а также принимать предусмотренные законом меры по
                защите своих прав;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                дать предварительное согласие на обработку персональных данных в
                целях продвижения на рынке товаров, работ и услуг;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                обжаловать в Роскомнадзоре или в судебном порядке неправомерные
                действия или бездействие Оператора при обработке его
                персональных данных.
              </span>
            </li>
          </ol>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.8. Контроль за исполнением требований настоящей Политики
              осуществляется уполномоченным лицом, ответственным за организацию
              обработки персональных данных у Оператора.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              1.9. Ответственность за нарушение требований законодательства
              Российской Федерации и нормативных актов Оператора в сфере
              обработки и защиты персональных данных определяется в соответствии
              с законодательством Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                2. ЦЕЛИ СБОРА ПЕРСОНАЛЬНЫХ ДАННЫХ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              2.1. Обработка персональных данных ограничивается достижением
              конкретных, заранее определенных и законных целей. Не допускается
              обработка персональных данных, несовместимая с целями сбора
              персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              2.2. Обработке подлежат только персональные данные, которые
              отвечают целям их обработки.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              2.3. Обработка Оператором персональных данных осуществляется в
              следующих целях:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                осуществление своей деятельности в соответствии с уставом
                Оператора, в том числе заключение и исполнение договоров с
                контрагентами;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                исполнение трудового законодательства в рамках трудовых и иных
                непосредственно связанных с ним отношений, в том числе:
                содействие работникам в трудоустройстве, получении образования и
                продвижении по службе, привлечение и отбор кандидатов на работу
                у Оператора, обеспечение личной безопасности работников,
                контроль количества и качества выполняемой работы, обеспечение
                сохранности имущества, ведение кадрового и бухучета, заполнение
                и передача в уполномоченные органы требуемых форм отчетности,
                организация постановки на индивидуальный (персонифицированный)
                учет работников в системах обязательного пенсионного страхования
                и обязательного социального страхования
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                .
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              2.4. Обработка персональных данных работников может осуществляться
              исключительно в целях обеспечения соблюдения законов и иных
              нормативных правовых актов.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                3. ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              3.1. Правовым основанием обработки персональных данных является
              совокупность нормативных правовых актов, во исполнение которых и в
              соответствии с которыми Оператор осуществляет обработку
              персональных данных, в том числе:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                Конституция Российской Федерации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                Гражданский кодекс Российской Федерации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                Трудовой кодекс Российской Федерации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                Налоговый кодекс Российской Федерации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                Федеральный закон от 12.01.1996&nbsp;
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                N
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                &nbsp;7-ФЗ "О некоммерческих организациях";
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                Федеральный закон от 06.12.2011&nbsp;
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                N
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                &nbsp;402-ФЗ "О бухгалтерском учете";
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                Федеральный закон от 15.12.2001&nbsp;
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                N
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                &nbsp;167-ФЗ "Об обязательном пенсионном страховании в
                Российской Федерации";
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные нормативные правовые акты, регулирующие отношения,
                связанные с деятельностью&nbsp;
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                Оператора.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              3.2. Правовым основанием обработки персональных данных также
              являются:
            </span>
          </p>
          <ul style={{ listStyleType: "disc", marginLeft: 17 }}>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                У
              </span>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                став Оператора;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                договоры, заключаемые между Оператором и субъектами персональных
                данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                согласие субъектов персональных данных на обработку их
                персональных данных (формы согласий субъектов персональных
                данных на обработку персональных данных, а также иные согласия
                приведены в Приложения №1 к Политике).
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                Локальные акты Оператора, в соответствии с которыми
                осуществляется обработка персональных данных.&nbsp;
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                4. ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ,
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.1. Содержание и объем обрабатываемых персональных данных должны
              соответствовать заявленным целям обработки, предусмотренным в
              разд. 2 настоящей Политики. Обрабатываемые персональные данные не
              должны быть избыточными по отношению к заявленным целям их
              обработки.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2. Оператор может обрабатывать персональные данные следующих
              категорий субъектов персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2.1. Кандидаты для приема на работу к Оператору - для целей
              исполнения трудового законодательства в рамках трудовых и иных
              непосредственно связанных с ним отношений, осуществления
              пропускного режима:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                фамилия, имя, отчество;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                пол;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                гражданство;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                дата и место рождения;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                контактные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                сведения об образовании, опыте работы, квалификации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные персональные данные, сообщаемые кандидатами в резюме и
                сопроводительных письмах.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2.2. Работники и бывшие работники Оператора - для целей
              исполнения трудового законодательства в рамках трудовых и иных
              непосредственно связанных с ним отношений, осуществления
              пропускного режима:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                фамилия, имя, отчество;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                пол;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                гражданство;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                дата и место рождения;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                изображение (фотография);
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                паспортные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                адрес регистрации по месту жительства;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                адрес фактического проживания;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                контактные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                индивидуальный номер налогоплательщика;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                страховой номер индивидуального лицевого счета (СНИЛС);
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                сведения об образовании, квалификации, профессиональной
                подготовке и повышении квалификации;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                семейное положение, наличие детей, родственные связи;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                сведения о трудовой деятельности, в том числе наличие поощрений,
                награждений и (или) дисциплинарных взысканий;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                данные о регистрации брака;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                сведения о воинском учете;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                сведения об инвалидности;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                сведения об удержании алиментов;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                сведения о доходе с предыдущего места работы;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные персональные данные, предоставляемые работниками в
                соответствии с требованиями трудового законодательства.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2.3. Члены семьи работников Оператора - для целей исполнения
              трудового законодательства в рамках трудовых и иных
              непосредственно связанных с ним отношений:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                фамилия, имя, отчество;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                степень родства;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                год рождения;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные персональные данные, предоставляемые работниками в
                соответствии с требованиями трудового законодательства.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2.4. Клиенты и контрагенты Оператора, в том числе субъекты
              креативных индустрий (физические лица)
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              - для целей осуществления своей деятельности в соответствии с
              Уставом Оператора:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                фамилия, имя, отчество;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                дата и место рождения;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                паспортные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                адрес регистрации по месту жительства;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                контактные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                замещаемая должность;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                индивидуальный номер налогоплательщика;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                номер расчетного счета;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные персональные данные, предоставляемые клиентами и
                контрагентами, в том числе субъектами креативных индустрий
                (физическими лицами), необходимые для заключения и исполнения
                договоров и соглашений.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.2.5. Представители (работники) клиентов и контрагентов
              Оператора, в том числе субъектов креативных индустрий (юридических
              лиц)
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              - для целей осуществления своей деятельности в соответствии с
              Уставом Оператора, осуществления пропускного режима:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                фамилия, имя, отчество;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                паспортные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                контактные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: 19,
              // }}
              >
                замещаемая должность;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иные персональные данные, предоставляемые представителями
                (работниками) клиентов и контрагентов, в том числе субъектами
                креативных индустрий (физическими лицами), необходимые для
                заключения и исполнения договоров и соглашений.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.3. Обработка Оператором биометрических персональных данных
              (сведений, которые характеризуют физиологические и биологические
              особенности человека, на основании которых можно установить его
              личность) осуществляется в соответствии с законодательством
              Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              4.4. Оператором не осуществляется обработка специальных категорий
              персональных данных, касающихся расовой, национальной
              принадлежности, политических взглядов, религиозных или философских
              убеждений, состояния здоровья,
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              интимной жизни, за исключением случаев, предусмотренных
              законодательством РФ.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                5. ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.1. Обработка персональных данных осуществляется Оператором в
              соответствии с требованиями законодательства Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.2. Обработка персональных данных осуществляется с согласия
              субъектов персональных данных на обработку их персональных данных,
              а также без такового в случаях, предусмотренных законодательством
              Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.3. Оператор осуществляет обработку персональных данных для
              каждой цели их обработки следующими способами:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 26 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                неавтоматизированная обработка персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                автоматизированная обработка персональных данных с передачей
                полученной информации по информационно-телекоммуникационным
                сетям или без таковой;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                смешанная обработка персональных данных.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.4. К обработке персональных данных допускаются работники
              Оператора, в должностные обязанности которых входит обработка
              персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.5. Обработка персональных данных для каждой цели обработки,
              указанной в п. 2.3 Политики, осуществляется путем:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                получения персональных данных в устной и письменной форме
                непосредственно от субъектов персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                внесения персональных данных в журналы, реестры и информационные
                системы Оператора;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                использования иных способов обработки персональных данных.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.6. Не допускается раскрытие третьим лицам и распространение
              персональных данных без согласия субъекта персональных данных,
              если иное не предусмотрено федеральным законом. Согласие на
              обработку персональных данных, разрешенных субъектом персональных
              данных для распространения, оформляется отдельно от иных согласий
              субъекта персональных данных на обработку его персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Требования к содержанию согласия на обработку персональных данных,
              разрешенных субъектом персональных данных для распространения,
              утверждены Приказом Роскомнадзора от 24.02.2021 № 18 "Об
              утверждении требований к содержанию согласия на обработку
              персональных данных, разрешенных субъектом персональных данных для
              распространения" (зарегистрировано в Минюсте России 21.04.2021 №
              63204)
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.7. Передача персональных данных органам дознания и следствия, в
              Федеральную налоговую службу, Социальный фонд России и другие
              уполномоченные органы исполнительной власти и организации
              осуществляется в соответствии с требованиями законодательства
              Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.8. Оператор принимает необходимые правовые, организационные и
              технические меры для защиты персональных данных от неправомерного
              или случайного доступа к ним, уничтожения, изменения,
              блокирования, распространения и других несанкционированных
              действий, в том числе:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                определяет угрозы безопасности персональных данных при их
                обработке;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                принимает локальные нормативные акты и иные документы,
                регулирующие отношения в сфере обработки и защиты персональных
                данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                назначает лиц, ответственных за обеспечение безопасности
                персональных данных в структурных подразделениях и
                информационных системах Оператора;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                создает необходимые условия для работы с персональными данными;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                организует учет документов, содержащих персональные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                организует работу с информационными системами, в которых
                обрабатываются персональные данные;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                хранит персональные данные в условиях, при которых
                обеспечивается их сохранность и исключается неправомерный доступ
                к ним;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                организует обучение работников Оператора, осуществляющих
                обработку персональных данных.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.9. Оператор осуществляет хранение персональных данных в форме,
              позволяющей определить субъекта персональных данных, не дольше,
              чем этого требует каждая цель обработки персональных данных, если
              срок хранения персональных данных не установлен федеральным
              законом, договором.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.9.1. Персональные данные на бумажных носителях хранятся у
              Оператора в течение сроков хранения документов, для которых эти
              сроки предусмотрены законодательством об архивном деле в РФ
              (Федеральный закон от 22.10.2004 № 125-ФЗ "Об архивном деле в
              Российской Федерации", Перечень типовых управленческих архивных
              документов, образующихся в процессе деятельности государственных
              органов, органов местного самоуправления и организаций, с
              указанием сроков их хранения (утв. Приказом Росархива от
              20.12.2019 № 236)).
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.9.2. Срок хранения персональных данных, обрабатываемых в
              информационных системах персональных данных, соответствует сроку
              хранения персональных данных на бумажных носителях.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.10. Оператор прекращает обработку персональных данных в
              следующих случаях:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 26 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                выявлен факт их неправомерной обработки. Срок - в течение трех
                рабочих дней с даты выявления;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                достигнута цель их обработки;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                истек срок действия или отозвано согласие субъекта персональных
                данных на обработку указанных данных, когда по Закону о
                персональных данных обработка этих данных допускается только с
                согласия.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.11. При достижении целей обработки персональных данных, а также
              в случае отзыва субъектом персональных данных согласия на их
              обработку Оператор прекращает обработку этих данных, если:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 26 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                иное не предусмотрено договором, стороной которого,
                выгодоприобретателем или поручителем по которому является
                субъект персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                Оператор не вправе осуществлять обработку без согласия субъекта
                персональных данных на основаниях, предусмотренных Законом о
                персональных данных или иными федеральными законами;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                иное не предусмотрено другим соглашением между Оператором и
                субъектом персональных данных.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.12. При обращении субъекта персональных данных к Оператору с
              требованием о прекращении обработки персональных данных в срок, не
              превышающий 10 рабочих дней с даты получения Оператором
              соответствующего требования, обработка персональных данных
              прекращается, за исключением случаев, предусмотренных Законом о
              персональных данных. Указанный срок может быть продлен, но не
              более чем на пять рабочих дней. Для этого Оператору необходимо
              направить субъекту персональных данных мотивированное уведомление
              с указанием причин продления срока.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              5.13. При сборе персональных данных, в том числе посредством
              информационно-телекоммуникационной сети Интернет, Оператор
              обеспечивает запись, систематизацию, накопление, хранение,
              уточнение (обновление, изменение), извлечение персональных данных
              граждан Российской Федерации с использованием баз данных,
              находящихся на территории Российской Федерации, за исключением
              случаев, указанных в Законе о персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                6. АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ, УНИЧТОЖЕНИЕ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                ПЕРСОНАЛЬНЫХ ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "center",
          // }}
          >
            <strong>
              <span
              // style={{
              //   fontSize: 19,
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                К ПЕРСОНАЛЬНЫМ ДАННЫМ
              </span>
            </strong>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.1. Подтверждение факта обработки персональных данных Оператором,
              правовые основания и цели обработки персональных данных, а также
              иные сведения, указанные в ч. 7 ст. 14 Закона о персональных
              данных, предоставляются Оператором субъекту персональных данных
              или его представителю в течение 10 рабочих дней с момента
              обращения либо получения запроса субъекта персональных данных или
              его представителя. Данный срок может быть продлен, но не более чем
              на пять рабочих дней. Для этого Оператору следует направить
              субъекту персональных данных мотивированное уведомление с
              указанием причин продления срока предоставления запрашиваемой
              информации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              В предоставляемые сведения не включаются персональные данные,
              относящиеся к другим субъектам персональных данных, за исключением
              случаев, когда имеются законные основания для раскрытия таких
              персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Запрос должен содержать:
            </span>
          </p>
          <ul style={{ listStyleType: "disc", marginLeft: 17 }}>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                номер основного документа, удостоверяющего личность субъекта
                персональных данных или его представителя, сведения о дате
                выдачи указанного документа и выдавшем его органе;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                сведения, подтверждающие участие субъекта персональных данных в
                отношениях с Оператором (номер договора, дата заключения
                договора, условное словесное обозначение и (или) иные сведения),
                либо сведения, иным образом подтверждающие факт обработки
                персональных данных Оператором;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                подпись субъекта персональных данных или его представителя.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Запрос может быть направлен в форме электронного документа и
              подписан электронной подписью в соответствии с законодательством
              Российской Федерации.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Оператор предоставляет сведения, указанные в ч. 7 ст. 14 Закона о
              персональных данных, субъекту персональных данных или его
              представителю в той форме, в которой направлены соответствующие
              обращение либо запрос, если иное не указано в обращении или
              запросе.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Если в обращении (запросе) субъекта персональных данных не
              отражены в соответствии с требованиями Закона о персональных
              данных все необходимые сведения или субъект не обладает правами
              доступа к запрашиваемой информации, то ему направляется
              мотивированный отказ.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              Право субъекта персональных данных на доступ к его персональным
              данным может быть ограничено в соответствии с ч. 8 ст. 14 Закона о
              персональных данных, в том числе если доступ субъекта персональных
              данных к его персональным данным нарушает права и законные
              интересы третьих лиц.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.2. В случае выявления неточных персональных данных при обращении
              субъекта персональных данных или его представителя либо по их
              запросу или по запросу Роскомнадзора Оператор осуществляет
              блокирование персональных данных, относящихся к этому субъекту
              персональных данных, с момента такого обращения или получения
              указанного запроса на период проверки, если блокирование
              персональных данных не нарушает права и законные интересы субъекта
              персональных данных или третьих лиц.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              В случае подтверждения факта неточности персональных данных
              Оператор на основании сведений, представленных субъектом
              персональных данных или его представителем либо Роскомнадзором,
              или иных необходимых документов уточняет персональные данные в
              течение семи рабочих дней со дня представления таких сведений и
              снимает блокирование персональных данных.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.3. В случае выявления неправомерной обработки персональных
              данных при обращении (запросе) субъекта персональных данных или
              его представителя либо Роскомнадзора Оператор осуществляет
              блокирование неправомерно обрабатываемых персональных данных,
              относящихся к этому субъекту персональных данных, с момента такого
              обращения или получения запроса.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.4. При выявлении Оператором, Роскомнадзором или иным
              заинтересованным лицом факта неправомерной или случайной передачи
              (предоставления, распространения) персональных данных (доступа к
              персональным данным), повлекшей нарушение прав субъектов
              персональных данных, Оператор:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 26 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                в течение 24 часов - уведомляет Роскомнадзор о произошедшем
                инциденте, предполагаемых причинах, повлекших нарушение прав
                субъектов персональных данных, предполагаемом вреде, нанесенном
                правам субъектов персональных данных, и принятых мерах по
                устранению последствий инцидента, а также предоставляет сведения
                о лице, уполномоченном Оператором на взаимодействие с
                Роскомнадзором по вопросам, связанным с инцидентом;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                в течение 72 часов - уведомляет Роскомнадзор о результатах
                внутреннего расследования выявленного инцидента и предоставляет
                сведения о лицах, действия которых стали его причиной (при
                наличии).
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.5. Порядок уничтожения персональных данных Оператором.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.5.1. Условия и сроки уничтожения персональных данных Оператором:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 26 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                достижение цели обработки персональных данных либо утрата
                необходимости достигать эту цель - в течение 30 дней;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                достижение максимальных сроков хранения документов, содержащих
                персональные данные, - в течение 30 дней;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                предоставление субъектом персональных данных (его
                представителем) подтверждения того, что персональные данные
                получены незаконно или не являются необходимыми для заявленной
                цели обработки, - в течение семи рабочих дней;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              //   fontSize: "14.0pt",
              // }}
              >
                отзыв субъектом персональных данных согласия на обработку его
                персональных данных, если их сохранение для цели их обработки
                более не требуется, - в течение 30 дней.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "35.4pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.5.2. При достижении цели обработки персональных данных, а также
              в случае отзыва субъектом персональных данных согласия на их
              обработку персональные данные подлежат уничтожению, если:
            </span>
          </p>
          <ul
          // className="decimal_type"
          // style={{ listStyleType: "disc", marginLeft: 17 }}
          >
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иное не предусмотрено договором, стороной которого,
                выгодоприобретателем или поручителем по которому является
                субъект персональных данных;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                оператор не вправе осуществлять обработку без согласия субъекта
                персональных данных на основаниях, предусмотренных Законом о
                персональных данных или иными федеральными законами;
              </span>
            </li>
            <li>
              <span
              // style={{
              //   lineHeight: "115%",
              //   fontFamily: '"Times New Roman",serif',
              // }}
              >
                иное не предусмотрено другим соглашением между Оператором и
                субъектом персональных данных.
              </span>
            </li>
          </ul>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.5.3. Уничтожение персональных данных осуществляет комиссия,
              созданная приказом директора Оператора.
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          //   textAlign: "justify",
          //   textIndent: "27.0pt",
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              6.5.4. Способы уничтожения персональных данных устанавливаются в
              локальных нормативных актах Оператора.
            </span>
          </p>
          <p>
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              <br />
              &nbsp;
            </span>
          </p>
          <p
          // style={{
          //   marginTop: "0cm",
          //   marginRight: "0cm",
          //   marginBottom: "0cm",
          //   marginLeft: "0cm",
          //   lineHeight: "115%",
          //   fontSize: 15,
          //   fontFamily: '"Calibri",sans-serif',
          // }}
          >
            <span
            //   style={{
            //     fontSize: 19,
            //     lineHeight: "115%",
            //     fontFamily: '"Times New Roman",serif',
            //   }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
              textIndent: "1.0cm",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                Согласие физического лица&nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
              textIndent: "1.0cm",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                на обработку персональных данных&nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
              textIndent: "1.0cm",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                &nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Я, __________________________(ФИО), паспорт серия: __, № ___,
              выдан: ____________ года
              _________________________________________________, № подразделения
              _______________, зарегистрирован(а) по адресу
              __________________________________________________,&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - в лице представителя субъекта персональных данных (
              <em>
                заполняется в случае получения согласия от представителя
                субъекта персональных данных)&nbsp;
              </em>
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;____________________________________________________________________________________
              (Ф.И.О. полностью), основной документ, удостоверяющий личность:
              ___________________________________________ (наименование, серия,
              номер, дата выдачи, выдавший орган), зарегистрированный(-ая) по
              адресу:
              ____________________________________________________________________________________,
              ____________________________________________________________________________________
              (реквизиты доверенности или иного документа, подтверждающего
              полномочия представителя),
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              в соответствии с&nbsp;
            </span>
            <a
              href="https://login.consultant.ru/link/?req=doc;base=LAW;n=213190;fld=134;dst=100282"
              title="https://login.consultant.ru/link/?req=doc;base=LAW;n=213190;fld=134;dst=100282"
            >
              <span
                style={{
                  fontSize: 16,
                  fontFamily: '"Times New Roman",serif',
                  color: "windowtext",
                  textDecoration: "none",
                }}
              >
                п. 4 ст. 9
              </span>
            </a>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;Федерального закона от 27.07.2006 &nbsp;№ 152-ФЗ &nbsp;«О
              персональных данных»{" "}
              <strong>заявляю о том, что ознакомлен (а)&nbsp;</strong>
            </span>
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                c
              </span>
            </strong>
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                &nbsp;Политикой в отношении обработки персональных данных
              </span>
            </strong>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;Оператора обработки персональных данных - Автономной
              некоммерческой организации «Сибирский институт развития креативных
              индустрий», АНО «СИРКИ» (660017, г. Красноярск ул. Красной Армии
              д.10 стр.3, пом. 302) (далее – Организация) на сайте Организации
            </span>{" "}
            (сайты &nbsp;<a href="http://industry.art">http://industry.art</a>{" "}
            <a href="http://place.industry.art">http://place.industry.art</a>
            &nbsp; &nbsp;
            <a href="http://битвакреаторов.рф">http://битвакреаторов.рф</a>{" "}
            приложение industry.art)
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              и свободно, своей волей и в своем интересе{" "}
              <strong>даю согласие</strong> уполномоченным лицам Организации{" "}
              <strong>на обработку</strong> (любое действие (операцию) или
              совокупность действий(операций), совершаемых с использованием
              средств автоматизации или без использования таких средств, включая
              сбор, запись, систематизацию, накопление, хранение, уточнение
              &nbsp;(обновление, изменение), извлечение, использование, передачу
              ( предоставление, доступ),обезличивание, блокирование, удаление,
              уничтожение) <strong>персональных сведений</strong> о:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              фамилии, имени, отчестве, поле, возрасте, дате и месте рождения,
              гражданстве, номере основного документа, удостоверяющего личность,
              сведения о дате выдачи указанного документа и выдавшем его органе,
              адресе регистрации по месту жительства, адресе фактического
              проживания, индивидуальном номере налогоплательщика; страховом
              номере индивидуального лицевого счета; номере телефона, адресе
              электронной почты, деловых и иных личных качествах, носящих
              оценочный характер; &nbsp;иной информации, относящаяся к
              персональным данным и предоставленной мной в Организацию.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Я даю свое согласие Организации на обработку (любое действие
              (операцию) или совокупность действий (операций), совершаемых с
              использованием средств автоматизации или без использования таких
              средств, включая сбор, запись, систематизацию, накопление,
              хранение, уточнение &nbsp;(обновление, изменение), извлечение,
              использование, передачу ( предоставление, доступ), обезличивание,
              блокирование, удаление, уничтожение) моих биометрических
              персональных данных, то есть сведений, которые характеризуют
              физиологические и биологические мои особенности, на основании
              которых можно установить мою личность и которые используются для
              установления моей личности (фотоизображение, видеозаписи).
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Вышеуказанные персональные данные и биометрические персональные
              данные предоставляю для обработки <strong>в целях</strong>
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;осуществления Организацией своей деятельности в соответствии
              с уставом Организации.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Согласие &nbsp;на &nbsp; обработку &nbsp;персональных &nbsp;данных
              действует неограниченный срок и может &nbsp;быть &nbsp; отозвано
              мной на основании письменного заявления в произвольной форме.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              В случае отзыва согласия на обработку персональных данных
              Организация вправе продолжить обработку персональных данных без
              согласия при наличии оснований, указанных в&nbsp;
            </span>
            <a
              href="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3CD727rAD"
              title="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3CD727rAD"
            >
              <span
                style={{
                  fontSize: 16,
                  fontFamily: '"Times New Roman",serif',
                  color: "windowtext",
                  textDecoration: "none",
                }}
              >
                пунктах &nbsp;2
              </span>
            </a>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;-&nbsp;
            </span>
            <a
              href="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3CD727r3D"
              title="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3CD727r3D"
            >
              <span
                style={{
                  fontSize: 16,
                  fontFamily: '"Times New Roman",serif',
                  color: "windowtext",
                  textDecoration: "none",
                }}
              >
                11 части &nbsp;1 &nbsp; статьи 6
              </span>
            </a>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              ,&nbsp;
            </span>
            <a
              href="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3ED927r8D"
              title="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C39479C69F3ED927r8D"
            >
              <span
                style={{
                  fontSize: 16,
                  fontFamily: '"Times New Roman",serif',
                  color: "windowtext",
                  textDecoration: "none",
                }}
              >
                части 2 статьи 10
              </span>
            </a>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;и&nbsp;
            </span>
            <a
              href="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C394792Cr4D"
              title="consultantplus://offline/ref=AF79A96AFC460150870335FA46A6821565B9B85BE1FF33469ADD43A9A9EB9FE286C394792Cr4D"
            >
              <span
                style={{
                  fontSize: 16,
                  fontFamily: '"Times New Roman",serif',
                  color: "windowtext",
                  textDecoration: "none",
                }}
              >
                части 2 статьи 11
              </span>
            </a>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;Федерального закона от 27 июля 2006 г. № 152-ФЗ «О
              персональных данных».
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              После прекращения любых правоотношений с Организацией в
              соответствии с Уставом Организации персональные данные будут
              храниться в Организации в течение предусмотренного
              законодательством Российской Федерации и иными нормативными
              правовыми актами Российской Федерации срока хранения документов.
            </span>
          </p>
          <p
            style={{
              marginTop: "11.0pt",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "27.0pt",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Доверенность представителя (иные документы, подтверждающие
              полномочия представителя) от "__"______ ___ г. № __ (
              <em>
                если согласие подписывается представителем субъекта персональных
                данных
              </em>
              ).
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "1.0cm",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "1.0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <table style={{ borderCollapse: "collapse", border: "none" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "106.8pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      ________________
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "157pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      _______________________
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "76.8pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      ____.________.20__
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "106.8pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      подпись
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "157pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      инициалы, фамилия
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "76.8pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <table style={{ border: "none", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "37.8pt",
                            border: "1pt none black",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                              }}
                            >
                              Дата
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "3.85pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "4.25pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "4.25pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "3.45pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "3.85pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                        <td
                          style={{
                            width: "4.25pt",
                            borderTop: "1pt none black",
                            borderRight: "1pt none black",
                            borderBottom: "1pt none black",
                            borderImage: "initial",
                            borderLeft: "none",
                            padding: "0cm 1.5pt",
                            height: "10.3pt",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              marginTop: "0cm",
                              marginRight: "0cm",
                              marginBottom: "0cm",
                              marginLeft: "0cm",
                              lineHeight: "106%",
                              fontSize: 15,
                              fontFamily: '"Calibri",sans-serif',
                            }}
                          >
                            <span
                              style={{
                                fontSize: 16,
                                lineHeight: "106%",
                                fontFamily: '"Times New Roman",serif',
                                color: "black",
                              }}
                            >
                              &nbsp;
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            style={{
              width: "5.8e+2pt",
              border: "none",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    width: "511.8pt",
                    border: "1pt none black",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "-67.15pt",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "justify",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "-67.15pt",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "justify",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "10.35pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "15.6pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "15.6pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "5.15pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "10.3pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "15.6pt",
                    borderTop: "1pt none black",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderImage: "initial",
                    borderLeft: "none",
                    padding: "0cm 1.5pt",
                    height: "10.3pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "106%",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        lineHeight: "106%",
                        fontFamily: '"Times New Roman",serif',
                        color: "black",
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "11.0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p>
            <span
              style={{
                fontSize: 16,
                lineHeight: "115%",
                fontFamily: '"Times New Roman",serif',
              }}
            >
              <br />
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "10.0pt",
              marginLeft: "0cm",
              lineHeight: "115%",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 16,
                  lineHeight: "115%",
                  fontFamily: '"Times New Roman",serif',
                }}
              >
                &nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Директору автономной некоммерческой организации&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              "Сибирский институт развития&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              креативных индустрий"&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              (АНО «СИРКИ)
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              А.И. Черникову
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              от
            </span>
          </p>
          <table
            style={{
              marginLeft: "310.2pt",
              borderCollapse: "collapse",
              border: "none",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderWidth: "1pt",
                    borderStyle: "none none solid",
                    borderColor: "black black windowtext",
                    borderImage: "initial",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderLeft: "1pt none black",
                    borderImage: "initial",
                    borderTop: "none",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      (фамилия, имя, отчество)
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderTop: "none",
                    borderLeft: "1pt none black",
                    borderBottom: "1pt solid windowtext",
                    borderRight: "1pt none black",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "justify",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderLeft: "1pt none black",
                    borderImage: "initial",
                    borderTop: "none",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      (почтовый адрес субъекта
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderTop: "none",
                    borderLeft: "1pt none black",
                    borderBottom: "1pt solid windowtext",
                    borderRight: "1pt none black",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "justify",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderLeft: "1pt none black",
                    borderImage: "initial",
                    borderTop: "none",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      персональных данных)
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderTop: "none",
                    borderLeft: "1pt none black",
                    borderBottom: "1pt solid windowtext",
                    borderRight: "1pt none black",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderTop: "none",
                    borderLeft: "1pt none black",
                    borderBottom: "1pt solid windowtext",
                    borderRight: "1pt none black",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      &nbsp;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "239.2pt",
                    borderRight: "1pt none black",
                    borderBottom: "1pt none black",
                    borderLeft: "1pt none black",
                    borderImage: "initial",
                    borderTop: "none",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      (номер телефона,&nbsp;
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 13,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      адрес электронной почты)
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                &nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                Согласие
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                на обработку персональных данных,
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                разрешенных субъектом персональных данных&nbsp;
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "center",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                для распространения
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "right",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Я,_______________________________________________________,
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              (фамилия, имя, отчество полностью)
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              в соответствии со ст. 10.1 Федерального закона от 27.07.2006 №
              152-ФЗ "О персональных данных", <strong>в целях:</strong>
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - осуществления Организацией своей деятельности в соответствии с
              уставом Организации;
              __________________________________________(указать иную цель)
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <strong>
              <span
                style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
              >
                даю согласие&nbsp;
              </span>
            </strong>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              автономной некоммерческой организации "Сибирский институт развития
              креативных индустрий" (АНО «СИРКИ»), расположенной по адресу: г.
              Красноярск, ул. Красной Армии, 10 стр.4 (ИНН 2466291084, ОГРН
              1222400007500, сведения об информационных ресурсах
              Организатора:&nbsp;
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              www
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              .
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              industry
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              .
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              art
            </span>
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              ), на обработку в форме распространения моих персональных данных
              неограниченному кругу лиц.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Категории и перечень моих персональных данных, на обработку в
              форме распространения которых я даю согласие:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              1. Персональные данные:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - фамилия, имя, отчество;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - информация о поле, возрасте, дате и месте рождения, гражданстве,
              номере основного документа, удостоверяющего личность, сведения о
              дате выдачи указанного документа и выдавшем его органе адресе
              регистрации по месту жительства, адресе фактического проживания,
              индивидуальном номере налогоплательщика; страховом номере
              индивидуального лицевого счета; номере телефона, адресе
              электронной почты, деловых и иных личных качествах, носящих
              оценочный характер;&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - иная информация, относящаяся к персональным данным и
              предоставленная мной в Организацию.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              2. Биометрические персональные данные:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              - фотографическое изображение.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Условия и запреты на обработку вышеуказанных персональных данных
              (ч. 9 ст. 10.1 Федерального закона от 27.07.2006 № 152-ФЗ "О
              персональных данных") (нужное отметить):
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              R
              <img
                width={19}
                src="data:image/png;base64,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"
                alt="Флажок со сплошной заливкой"
              />
              &nbsp; &nbsp;не устанавливаю
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              £&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;устанавливаю запрет на
              передачу (кроме предоставления доступа) этих данных оператором
              неограниченному кругу лиц
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              £&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;устанавливаю запрет на
              обработку (кроме получения доступа) этих данных неограниченным
              кругом лиц
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              £&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;устанавливаю условия
              обработки (кроме получения доступа) этих данных неограниченным
              кругом лиц:
              ________________________________________________________________________
              ___________________________________________________________________________________.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Условия, при которых полученные персональные данные могут
              передаваться оператором только по его внутренней сети,
              обеспечивающей доступ к информации лишь для строго определенных
              сотрудников, либо с использованием
              информационно-телекоммуникационных сетей, либо без передачи
              полученных персональных данных:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              не устанавливаю.&nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              Настоящее согласие действует со дня его подписания до дня отзыва в
              письменной форме.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <table style={{ borderCollapse: "collapse", border: "none" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "99pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      ________________
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "192.75pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      _________________________________
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "71.45pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      __.____.20__
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "99pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      подпись
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "192.75pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      инициалы, фамилия
                    </span>
                  </p>
                </td>
                <td
                  style={{
                    width: "71.45pt",
                    padding: "0cm 5.4pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: "0cm",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 16,
                        fontFamily: '"Times New Roman",serif',
                      }}
                    >
                      дата
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
              textIndent: "27.0pt",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "0cm",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              textAlign: "justify",
            }}
          >
            <span
              style={{ fontSize: 16, fontFamily: '"Times New Roman",serif' }}
            >
              &nbsp;
            </span>
          </p>
        </div>
      </Container>
    </PageTemplate>
  );
};

export default MobilePrivacy;
